













































































import Vue from 'vue';
import draggable from 'vuedraggable';
import { IExclusion } from '@/store/types';
import { mapGetters } from 'vuex';
import * as actions from '@/store/action-types';
import * as mutations from '@/store/mutation-types';
import ExclusionCard from '@/components/Reactivation/ExclusionCard.vue';
import CardLoader from '@/components/UI/Loader/CardLoader.vue';
import { descending } from 'd3-array';

export default Vue.extend({
  name: 'ReactivationExclusions',
  components: {
    draggable,
    ExclusionCard,
    CardLoader,
  },
  data() {
    return {
      drag: false as boolean,
      loading: true,
      publishLoading: {} as { [key: string]: boolean },
      creatingExclusion: false,
      publishing: false,
    };
  },
  async created() {
    await this.$store.dispatch(actions.SYNC_REACTIVATION);
    this.loading = false;
  },
  computed: {
    ...mapGetters(['reactivationExclusions']),
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    exclusions(): IExclusion[] {
      return this.reactivationExclusions?.filter(({ deleted }: IExclusion) => !deleted) || [];
    },
    enabledExclusions(): IExclusion[] {
      return this.exclusions.filter(({ enabled }) => !!enabled);
    },
    disabledExclusions(): IExclusion[] {
      return this.exclusions.filter(({ enabled }) => !enabled);
    },
  },
  methods: {
    handleEdit(exclusionId: string) {
      if (exclusionId) {
        this.$router.push({ name: 'reactivationexclusion', params: { id: exclusionId } });
      }
    },
    onDragEnd(order: { newIndex: number; oldIndex: number }) {
      if (order.newIndex !== order.oldIndex) {
        const exclusions = this.enabledExclusions.map(({ _id }) => _id);
        this.$store.dispatch(actions.UPDATE_REACTIVATION_EXCLUSIONS_ORDER, { exclusions });
      }
      this.drag = false;
    },
    async handlePublish(exclusionId: string, silent = false) {
      try {
        if (exclusionId) {
          this.publishLoading[exclusionId] = true;
          this.publishing = true;
          // TODO: implement publish
          await this.$store.dispatch(actions.PUBLISH_REACTIVATION_EXCLUSION, { id: exclusionId });
          this.publishLoading[exclusionId] = false;
          if (!silent) {
            this.$message.success("It's live! Exclusion rule successfully published.");
          }
          this.publishing = false;
        }
      } catch (e) {
        this.$message.error('Failed to publish exclusion rule. Please refresh and try again or contact us through chat');
        this.publishLoading[exclusionId] = false;
        console.log(e);
      }
    },
    handleDelete(exclusionId: string) {
      if (exclusionId) {
        this.$store.commit(mutations.STORE_REACTIVATION_EXCLUSION_DATA, { id: exclusionId, data: { deleted: true } });
        this.$store.dispatch(actions.SCHEDULE_SAVE_REACTIVATION_EXCLUSION, { id: exclusionId, delay: 0 });
      }
    },
    async handleDisable(exclusionId: string) {
      if (exclusionId) {
        this.$store.commit(mutations.STORE_REACTIVATION_EXCLUSION_DATA, { id: exclusionId, data: { enabled: false } });
        await this.$store.dispatch(actions.SCHEDULE_SAVE_REACTIVATION_EXCLUSION, { id: exclusionId, delay: 0 });
        this.handlePublish(exclusionId, true);
      }
    },
    async handleEnable(exclusionId: string) {
      if (exclusionId) {
        this.$store.commit(mutations.STORE_REACTIVATION_EXCLUSION_DATA, { id: exclusionId, data: { enabled: true } });
        await this.$store.dispatch(actions.SCHEDULE_SAVE_REACTIVATION_EXCLUSION, { id: exclusionId, delay: 0 });
        this.handlePublish(exclusionId);
      }
    },
  },
});
